import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { Department } from '../../parametrization/models/department';

/**
 * Base url for api
 */
const BASE_URL = 'departments';

@Injectable({
  providedIn: 'root'
})

/**
 * Department Service
 */
export class DepartmentService {

  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   * @param httpClient HttpClient
   * @param authenticationService AuthenticationService
   */
  constructor(private apiService: ApiService, private  httpClient: HttpClient, private authenticationService: AuthenticationService) {
    this.loading$ = this.apiService.loading$;
  }



  /**
   * list
   *
   */
  list(): Observable<Department[]> {
    return this.apiService.post(`${BASE_URL}/list`).pipe(map(
      departments => departments.map(
        (department) => Department.createFromJson(department))
      )
    );
  }


}
